import { isUndefined } from '../../utils/unit';
export function isReactiveElementProto(decoratorName, proto) {
    return isReactiveElementConstructor(decoratorName, proto.constructor);
}
export function isReactiveElementConstructor(decoratorName, ctor) {
    if (isUndefined(ctor.addInitializer)) {
        throw Error(`[vds]: \`${ctor.name}\` must extend \`ReactiveElement\` to use the \`@${decoratorName}\` decorator.`);
    }
    return true;
}
/**
 * TC39 Decorator
 *
 * @param decoratorName
 * @param context
 * @link https://github.com/tc39/proposal-decorators
 */
export function throwIfTC39Decorator(decoratorName, context) {
    if (Object.hasOwnProperty.call(context, 'kind')) {
        throw Error(`[@${decoratorName}] TC39 decorators are not supported yet.`);
    }
}
